export enum Roles {
  SUPERADMIN = 'superadmin',
  ADMIN = 'admin',
  OPERATOR = 'operator',
  USER = 'user',
}

export enum Profiles {
  USER_EDITOR = 'stock_editor',
  USER_READER = 'stock_reader'
}